export default "__VITE_ASSET__DjN6dsAX__"